import type { BaseBlock } from "../../DataModel.types";
import { getBlockPathInfo, getParentArray } from "../../Helpers/blockPath";
import type { ListPolicies, MoveDirection } from "../types";

const getCanMoveSelectedBlock = ({
  selectedBlockPath,
  getBlocks,
  listPolicies,
  direction,
}: {
  selectedBlockPath: string | null;
  getBlocks: () => BaseBlock;
  listPolicies: ListPolicies | undefined;
  direction: MoveDirection;
}) => {
  if (!selectedBlockPath) return false;

  const { currentIndex, relativeParentPath } =
    getBlockPathInfo(selectedBlockPath);
  if (currentIndex === -1) return false;

  const parentArray = getParentArray(getBlocks(), relativeParentPath);
  if (!parentArray) return false;

  const toIndex = direction === "up" ? currentIndex - 1 : currentIndex + 1;

  const policy = listPolicies?.[relativeParentPath];
  if (policy?.canMoveChild) {
    return policy.canMoveChild({
      parentArray,
      parentPath: relativeParentPath,
      fromIndex: currentIndex,
      toIndex,
      child: parentArray[currentIndex],
      direction,
    });
  }
  return direction === "up"
    ? currentIndex > 0
    : currentIndex < parentArray.length - 1;
};

export default getCanMoveSelectedBlock;
